import { render, staticRenderFns } from "./wpsa.vue?vue&type=template&id=76cd16bc&scoped=true&"
import script from "./wpsa.vue?vue&type=script&lang=js&"
export * from "./wpsa.vue?vue&type=script&lang=js&"
import style0 from "./wpsa.vue?vue&type=style&index=0&id=76cd16bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd16bc",
  null
  
)

export default component.exports